// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2Kfo-";
var _3 = "links-251-I";
var _4 = "text-2ZUAW";
var _5 = "wrapper-3E2uB";
var _6 = "authorized-2XCQW";
var _7 = "silver-1LuTn";
var _8 = "gold-3ar9Y";
var _9 = "diamond-1KpWW";
var _a = "temporary-2ZrJ5";
var _b = "header-3nNXW";
var _c = "info-2OIuh";
var _d = "footer-2bZEy";
export { _1 as "__esModule", _2 as "container", _3 as "links", _4 as "text", _5 as "wrapper", _6 as "authorized", _7 as "silver", _8 as "gold", _9 as "diamond", _a as "temporary", _b as "header", _c as "info", _d as "footer" }
export default { "__esModule": _1, "container": _2, "links": _3, "text": _4, "wrapper": _5, "authorized": _6, "silver": _7, "gold": _8, "diamond": _9, "temporary": _a, "header": _b, "info": _c, "footer": _d }
